import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required, emailValidator } from '../../../utilities/validators'
import Loader from '../../Loader/Loader'

const LoginForm = ({ loginLoading, handleSubmit, error, isModal = false }) => (
  <form onSubmit={handleSubmit} method="post" name="loginForm" aria-labelledby="login-form-title">
    <div id="login-form-title" className="sr-only">
      Login form
    </div>
    <div disabled={loginLoading}>
      <div className="sr-only">User login</div>
      <Field
        name="email"
        label="global.label.email"
        type="email"
        inputType="input"
        containerclass="form-group"
        component={renderField}
        validate={[required, emailValidator]}
      />
      <Field
        password
        name="password"
        label="global.label.password"
        type="password"
        inputType="input"
        containerclass="form-group"
        component={renderField}
        validate={[required]}
      />
      {error && (
        <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
          <FormattedMessage id={error} />
        </div>
      )}
      {loginLoading ? (
        <Loader aria-label="Logging in" />
      ) : (
        <Button
          type="submit"
          name="loginFormSubmitBtn"
          className="mt-3"
          outline
          color={isModal ? 'light' : 'dark'}
          block
          aria-disabled={loginLoading}
          aria-describedby={error ? 'login-form-error' : undefined}
        >
          <FormattedMessage id="global.label.login" />
        </Button>
      )}
    </div>
  </form>
)

export default reduxForm({
  form: 'LoginForm',
})(LoginForm)
